// Single composition point for the F1 data layer. App.tsx mounts this once at
// the root of the console subtree (every product-first route) and again around
// /login, so the urql client + AuthProvider + ErrorBoundary exist exactly once
// per tree.

import { useMemo } from "react";
import type { ReactNode } from "react";
import { Provider as UrqlProvider } from "urql";

import { ErrorBoundary } from "@/components/ErrorBoundary";
import { AuthProvider } from "@/lib/auth/AuthProvider";
import { createGraphqlClient } from "@/lib/gql/client";
import { WsProvider } from "@/lib/ws/WsProvider";

export function AppProviders({ children }: { children: ReactNode }) {
  const client = useMemo(() => createGraphqlClient(), []);
  return (
    <ErrorBoundary>
      <UrqlProvider value={client}>
        <AuthProvider>
          <WsProvider>{children}</WsProvider>
        </AuthProvider>
      </UrqlProvider>
    </ErrorBoundary>
  );
}
